import * as e from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/SmileySad.es.js";
const o = e.forwardRef((a, m) => /* @__PURE__ */ e.createElement(r, { ref: m, ...a, weights: t }));
o.displayName = "SmileySadIcon";
const s = o;
export {
  s as SmileySad,
  o as SmileySadIcon
};
